<template>
  <base-section
    id="sponsors"
  >
    <v-container>
    <base-section-heading
    title="Main Organizing Institution"
    color="secondary"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row align="center">
      <v-col
        cols="12"
        sm="4"
        md="3"
        class="align-self-center"
      >
        <base-img
          :src="require('@/assets/logo_inaoe.png')"
          color="grey"
          contain
          height="120"
          width="220"
          />
      </v-col>
      <v-col
        cols="12"
        sm="8"
        md="9"
        class="align-self-center"
      >
        <span class="text-h6">National Institute of Astrophysics, Optics and Electronics (INAOE)</span>
      </v-col>
    </v-row>
    <br><br><br>
    <base-section-heading
    title="Co-organizing Institution"
    color="secondary"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row align="center">
      <v-col
        cols="12"
        sm="4"
        md="3"
        class="align-self-center"
      >
        <base-img
          :src="require('@/assets/logo utec.png')"
          color="grey"
          contain
          height="120"
          width="220"
          />
      </v-col>
      <v-col
        cols="12"
        sm="8"
        md="9"
        class="align-self-center"
      >
        <span class="text-h6">Universidad de Ingenierìa</span>
      </v-col>
    </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Sponsors',
  }
</script>
